import { selectedCategoryDescriptions } from "#/admin/legacy/forms/category-description.js";
import { whenSelectsReady } from "#/admin/legacy/sp-select/when-selects-ready.js";

jQuery(function () {
  var categorySelect = '[data-behaviour~="category-select-field"]';
  var categoryFieldCommentSelector = ".dynamic-field-description";
  var categoryFieldCommentContainer = jQuery('<div class="field-comment dynamic-field-description"></div>');

  // BEHAVIOUR

  jQuery(document).on("change", categorySelect, handleDescriptionChange);

  // EVENT HANDLERS

  function handleDescriptionChange(event) {
    updateCategoryDescription(this);
  }

  // HELPER FUNCTIONS

  function addCategoryFieldComment(categoryField) {
    jQuery(categoryField).closest(".field").append(categoryFieldCommentContainer.clone());
  }

  function updateCategoryDescription(categoryField) {
    var field = jQuery(categoryField).closest(".field");
    var categoryFieldComment = field.find(categoryFieldCommentSelector);

    categoryFieldComment.empty();

    selectedCategoryDescriptions(categoryField).forEach(function (description) {
      categoryFieldComment.append(description);
    });
  }

  // INITIALIZE

  jQuery(categorySelect).each(function () {
    addCategoryFieldComment(this);
    whenSelectsReady([this], function initializeCategoryDescription([control]) {
      updateCategoryDescription(control);
    });
  });
});
